import { NAVY, SECTION_BACKGROUND } from 'styles/Colors';
import Container from '@opploans/container-component/Container';
import React from 'react';

const containerStyle = {
  textAlign: 'center',

  h1: {
    color: NAVY,
    fontSize: '1.5rem',
    fontWeight: 700
  },

  h2: {
    fontSize: '1.25rem'
  }
};

const accountLockedText = {
  marginTop: '2rem',
  textAlign: 'left'
};

function MfaLocked() {
  return (
    <Container
      additionalStyle={containerStyle}
      additionalOuterStyle={{ background: SECTION_BACKGROUND }}
    >
      <div>
        <h1>Account Locked</h1>
        <p css={accountLockedText}>
          Due to too many incorrect MFA attempts your account has been locked.
        </p>
        <p css={accountLockedText}>
          Please return back to attempt again later today.
        </p>
      </div>
    </Container>
  );
}

export default MfaLocked;
